
<v-col cols="12" md="12" class="pl-3 p-0">
  <span class="color-grey header"><b>Common Questions</b></span>
  <v-card style="background:transparent;" class="pt-2 mt-3">
    <div v-for="i in limit" v-show="loading">
      <v-skeleton-loader transition="scale-transition" type="text" class="p-2"></v-skeleton-loader>
    </div>
    <div v-if="commonQuestions.length > 0 && !loading">
      <v-card-subtitle v-for="article in commonQuestions" class="pt-0">
        <router-link :to="{ name: 'ArticleDetail', params:{id: article.sys.id, slug: article.fields.slug} }">
          <span @click="openArticle('topicId', article.sys.id)" class="color-black sub-header">{{article.fields.title}}</span>
        </router-link>
      </v-card-subtitle>
    </div>
    <div v-else>
      <v-card-subtitle v-if="!loading">
        <span class="color-grey text">No Common Questions.</span>
      </v-card-subtitle>
    </div>
  </v-card>
</v-col>
